module.exports = __webpack_public_path__ + "img/zs.af8872be.png";